export default "__VITE_ASSET__Bq2JC6er__"